<template>
  <div class="light-gray">
    <component @reDrawMemoImage="reDrawMemoImage" @emitReload="emitReload" :is="header" ref="headerRef"></component>
    <slot></slot>
    <component :is="footer"></component>
  </div>
</template>
<script>
import FloristHeader from '@/components/FloristHeader.vue'
import FloristFooter from '@/components/FloristFooter.vue'
import TraderHeader from '@/components/TraderHeader.vue'
import TraderFooter from '@/components/TraderFooter.vue'
import CustomerHeader from '@/components/CustomerHeader.vue'
import CustomerFooter from '@/components/CustomerFooter.vue'

export default {
  name: 'CommonLayout',
  props: ['header', 'footer'],
  components: {
    floristHeader: FloristHeader,
    floristFooter: FloristFooter,
    traderHeader: TraderHeader,
    traderFooter: TraderFooter,
    customerHeader: CustomerHeader,
    customerFooter: CustomerFooter
  },
  data () {
    return {
      userBrowser: ''
    }
  },
  methods: {
    reDrawMemoImage (projectNumber, projectType) {
      this.$emit('reDrawMemoImage', projectNumber, projectType)
    },
    emitReload () {
      this.$emit('emitReload')
    },
    deleteTabInfo (event) {
      localStorage.removeItem('tabInfo')
    },
    cookieProjectNumberCheck () {
      let cookieProjectNumberCheckResult = this.$refs.headerRef.cookieProjectNumberCheck()
      return cookieProjectNumberCheckResult
    }
  },
  mounted: function () {
    if (process.env.APP_ENV !== 'production') {
      document.title = '【テスト環境】' + this.config.projectName
    }
  },
  created () {
    var userAgent = window.navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
      this.userBrowser = 'IE'
    } else if (userAgent.indexOf('edg') !== -1) {
      this.userBrowser = 'Edge'
    } else if (userAgent.indexOf('chrome') !== -1) {
      this.userBrowser = 'Chrome'
    } else if (userAgent.indexOf('safari') !== -1) {
      this.userBrowser = 'Safari'
    } else if (userAgent.indexOf('firefox') !== -1) {
      this.userBrowser = 'FireFox'
    } else if (userAgent.indexOf('opera') !== -1) {
      this.userBrowser = 'Opera'
    }

    if (this.userBrowser !== 'Safari' && this.$route.path !== '/florist/meeting' && this.$route.path !== '/customer/direct_estimate') {
      localStorage.setItem('tabInfo', Date.now())
      window.addEventListener('beforeunload', this.deleteTabInfo)
    }
  },
  destroyed () {
    if (this.userBrowser !== 'Safari' && this.$route.path !== '/florist/meeting' && this.$route.path !== '/customer/direct_estimate') {
      window.removeEventListener('beforeunload', this.deleteTabInfo)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/CommonLayout.vue